import { connect } from 'react-redux';
import actions from 'actions/Chat';
import { currentUserSelectors, searchSelectors } from '@lifesize/nucleus';
import ChatSearchComp from 'components/Chat/Search/ChatSearch';
import _get from 'lodash/get';

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleSetIsFocused: (isFocused) => {
    dispatch(actions.setFormFocus(isFocused));
  },
  handleEnter: (selectedContact) => {
    ownProps.onSelectContact(selectedContact);
  }
});

function getMaxItems(searchResults) {
  const resultLength = searchResults.length || 1;
  return Math.min(resultLength, 6);
}

function mapStateToProps(state) {
  // We are NOT checking currentUserSelectors.myInfo(state).isSuperUser, because we only care about owner.
  const currentUserUuid = currentUserSelectors.getUserUUID(state);
  const searchString = _get(state, 'app.form.chatSearch.values.chatSearchBar');
  const allSearchResults = searchSelectors.searchChattableContacts(state);
  const filteredSearchResults = allSearchResults.filter(
    (rslt) =>
      !rslt.contact?.isMeeting ||
      // We do NOT check reslt.contact.moderator.uuid, because we do NOT want to show for moderators.
      rslt.contact?.owner?.uuid === currentUserUuid
  );
  const isFocused = _get(state, 'app.chat.isFocused');
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  const selectedContact = _get(filteredSearchResults[selectionIndex], 'contact');

  return {
    isFocused,
    maxItems: getMaxItems(filteredSearchResults),
    searchResults: filteredSearchResults,
    searchString,
    selectedContact
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatSearchComp);
